import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// The records inside one change order. Standalone rather than a member of
// ChangeOrder's EnterpriseObject: the grid is queried by ChangeOrderUSID and must not re-query when
// anything else on the page changes.
class ChangeOrderMemberEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ChangeOrderMember";
        this.primaryEnterpriseComponent = "ChangeOrderMember";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ChangeOrderMember";
        eom.enterpriseComponent = "ChangeOrderMember";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ChangeOrderMemberEnterpriseObjectMetadata;
